export default __webpack_public_path__ + "static/media/logo.56b25ead.svg";